import { useAccordionContext } from '../contexts/accordion-context';
import { useAccordionItemContext } from '../contexts/accordion-item-context';

export const useAccordionToggle = () => {
	const { setActiveValue } = useAccordionContext();
	const { value } = useAccordionItemContext();
	
	return () => {
		setActiveValue(prevValue => {
			return prevValue === value ? undefined : value
		});
	};
};
export const SimpleAccordionSummary = ({
	className, 
	children 
}: {
	className?: string;
	children: React.ReactNode;
}) => {
	const handleClick = useAccordionToggle();
	
	return (
		<div 
			className={className}
			onClick={handleClick}
		>
			{children}
		</div>
	);
};